// The tag-pick question (a classify variant): every name is shown as a tag,
// and the learner strikes out the ones Python refuses.

/**
 * The response to send: every tag present, struck ones as 'bad' and the rest
 * as 'ok'. A tag left alone is an answer too — "this one is allowed" — so a
 * learner who taps nothing still gets the allowed tags right.
 */
export function tagPickAnswers(items, struck) {
  return Object.fromEntries(items.map((item) => [item.id, struck.has(item.id) ? 'bad' : 'ok']));
}

/**
 * How many learners gave this item its correct answer, out of everyone who
 * answered, from a per-item tally. Null when the tally has no per-item counts.
 */
export function rightCount(tally, item) {
  if (!tally || tally.kind !== 'item-counts') return null;
  const row = tally.items.find((r) => r.id === item.id);
  return { right: row?.counts?.[item.answer] ?? 0, of: (tally.correct ?? 0) + (tally.incorrect ?? 0) };
}

/**
 * How a tag reads once the answer is out — the same on the projector and on
 * every phone: refused tags struck through with a cross, allowed ones with a
 * tick, each with its reason. It shows the key, not the learner's own picks,
 * so it stays right after a reload; the learner's own result is the banner.
 */
export function revealMark(item) {
  const bad = item.answer === 'bad';
  return {
    struck: bad,
    mark: bad ? '✗' : '✓',
    reason: item.reason || (bad ? 'ใช้ไม่ได้' : 'ใช้ได้'),
  };
}
